import { createSelector } from '@reduxjs/toolkit'

const getStatePayoutsDownload = state => state.payoutsDownload

export const getPayoutsDownload = createSelector(
  [getStatePayoutsDownload],
  product => product
)
